import {getFamilyPayPaymentInfo} from '@web/actions/familyPay'
import makeSlice from '@web/slices/agreement/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                state.mallContract = payload.saleChannelInfo.isCheckout
                state.openBankingAgreed = payload.agreement?.agreedOpenBank ?? true

                const isFamilyPayApiFailed = payload.familyPay?.apiResultType !== 'SUCCESS'
                const familyPayAgreed = payload.familyPay?.familyPayAgreement ?? true

                state.familyPayAgreed = isFamilyPayApiFailed ? undefined : familyPayAgreed

                state.selected = {
                    mallContract: true,
                    thirdPeople: true,
                    customOrder: true,
                    preOrder: true,
                    personalDataCrossBorderTransfer: true,
                    /** 패밀리결제 정보 api가 실패했거나 패밀리결제 기동의자는 true로 처리 */
                    familyPay: isFamilyPayApiFailed || familyPayAgreed,
                    booking: true,
                    shoppingSubscription: true,
                }
            })
            .addCase(getFamilyPayPaymentInfo.fulfilled, (state, {payload}) => {
                const isApiFailed = payload.apiResultType !== 'SUCCESS'

                state.selected = {
                    ...state.selected,
                    /** 패밀리결제 정보 api가 실패했거나 패밀리결제 기동의자는 true로 처리 */
                    familyPay: isApiFailed || payload.familyPayAgreement,
                }
                state.familyPayAgreed = isApiFailed ? undefined : payload.familyPayAgreement
            })
    },
})

export default slice.reducer
